import React from 'react';
import { StackedBar } from '../../../../../../../../CommonComponents/OPL/charts/StackedBar/StackedBar';
import { AssetAllocationDTO } from '../../../../../../api/useAccountsOptionsQuery';

interface Props {
  chartValues: AssetAllocationDTO[];
}

export const AssetAllocationStackChart = ({ chartValues }: Props) => {
  if (!chartValues) {
    return null;
  }

  return (
    <StackedBar
      data={chartValues.map(item => ({
        label: item.name,
        color: item.color,
        value: Number(item.y),
        id: item.name,
      }))}
    />
  );
};
